// extracted by mini-css-extract-plugin
export default {"subtitle__icon-container":"style_subtitle__icon-container__Etux8","subtitle__text":"style_subtitle__text__dbR8u"};